
/* UTILISATION */
export const QUERY_MANAGED_ASSETS = "QUERY_MANAGED_ASSETS";
export const RECEIVED_MANAGED_ASSETS = "RECEIVED_MANAGED_ASSETS";
export const TOGGLE_MODAL_VISIBILITY = "TOGGLE_MODAL_VISIBILITY";
export const UPDATE_UTILISATION = "UPDATE_UTILISATION";

